// @flow

import {getSingleColumnWidth} from './getSingleColumnWidth';
import type {Column} from '../typedef';

type GetColumnsWidthDataType = {|
    width: number,
    widthArray: Array<number>,
    offsetWidth: Array<number>,
|};

export const getColumnsWidthData = <DataColumn>(columns: Array<Column<DataColumn>>): GetColumnsWidthDataType => {
    return columns.reduce((all, i, index) => {
        const width = getSingleColumnWidth(i);
        return {
            width: all.width + width,
            widthArray: [...all.widthArray, width],
            offsetWidth: [
                ...all.offsetWidth,
                index === 0 ? 0 : all.offsetWidth[index - 1] + all.widthArray[index - 1]
            ]
        };
    }, {
        width: 0,
        widthArray: [],
        offsetWidth: []
    });
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
